import { render, staticRenderFns } from "./_member_field.vue?vue&type=template&id=04fa927c&lang=pug"
import script from "./_member_field.vue?vue&type=script&lang=js"
export * from "./_member_field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports